var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBaselineHammerBigCircle64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 45.5H33.5V48.5H15.5V45.5ZM21.86 26.105L26.105 21.86L47.315 43.07L43.07 47.315L21.86 26.105ZM32.48 15.5L40.97 23.99L36.725 28.235L28.235 19.745L32.48 15.5ZM19.745 28.22L28.235 36.71L23.99 40.955L15.5 32.465L19.745 28.22Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselineHammerBigCircle64Px);
export default __webpack_public_path__ + "static/media/ic_baseline-hammer_big_circle-64px.ecac28fcf2a5af1f4e5c2e82c8b02039.svg";
export { ForwardRef as ReactComponent };